export default "__VITE_ASSET__87a7d04f__"